import React from "react";

import { Icon } from "@iconify/react";

const SearchItems = ({ borderColor, image, detail, onClick, type }) => {
  return (
    <div className={Classname.mainContent} onClick={onClick}>
      <div className={Classname.box}>
        <div
          className={`h-[72px] w-[94px] border ${borderColor} rounded-[7px] flex items-center justify-center`}
        >
          <img src={image} alt="orderImages" />
        </div>
        <p className={Classname.details}>{detail}</p>
      </div>
      {type === "search" ? (
        <button onClick={onClick}>
          <Icon
            icon="material-symbols:add"
            className="text-darkGray text-2xl"
          />
        </button>
      ) : (
        <button className="bg-primary1 text-secondary text-sm font-bold px-6 py-1 rounded-[4px]">
          Add
        </button>
      )}
    </div>
  );
};

export default SearchItems;

const Classname = {
  mainContent:
    "rounded-lg cursor-pointer border border-grayBorder p-4 shadow flex justify-between items-center w-full",
  details: "font-semibold text-sm",
  box: "flex items-center gap-[9px]",
};
